export default {
  inventory: process.env.REACT_APP_INVENTORY ?? '',
  crm: process.env.REACT_APP_CRM ?? '',
  identity: process.env.REACT_APP_IDENTITY ?? ''
}
